module.exports = __webpack_public_path__ + "static/media/educadora.a079099a.png";